import CardClient from '@/model/CardClient';
import { UseFormControl } from 'src/types';

export interface PerfilParam {
  id: string;
}

export enum FormInputName {
  name = 'name',
  email = 'email',
  phone = 'phone',
  birthDate = 'birthDate',
  motherName = 'motherName',
}

export enum FormInputNamePassword {
  password = 'password',
  confirmPassword = 'confirmPassword',
}

export enum FormInputNameAddress {
  id = 'id',
  zipCode = 'zipCode',
  state = 'state',
  city = 'city',
  district = 'district',
  street = 'street',
  complement = 'complement',
  number = 'number',
}

export enum FormInputNameCreditCard {
  number = 'number',
  month = 'month',
  year = 'year',
  cvv = 'cvv',
  name = 'name',
  document = 'document',
}

export interface UseModalControl {
  visible: boolean;
  title: string | React.ReactNode;
  shouldShowModal: ShowModalProfile;
  onShouldShowModal: ({ value, newTitle }: ShouldShowModalProps) => void;
  onToggleModal: () => void;
  onSetVisible: (visible: boolean) => void;
}

export type ShouldShowModalProps = {
  value: ShowModalProfile;
  newTitle: string | React.ReactNode;
};

export enum ShowModalProfile {
  BIOMETRIC_FACE = 'BIOMETRIC_FACE',
  ADD_CREDIT_CARD = 'ADD_CREDIT_CARD',
  CONFIRM_DELETE_CREDIT_CARD = 'CONFIRM_DELETE_CREDIT_CARD',
  CONFIRM_DELETE_PROFILE = 'CONFIRM_DELETE_PROFILE',
}

export interface ControllerCreditCard {
  list: CardClient[];
  //   onShowAddCreditCard: () => void;
  onShowDeleteCreditCard: (cardId: string) => void;
  onSubmitDeleteCreditCard: () => void;
  controllerAddCreditCard: UseFormControl;
}

export interface ControllerDeleteProfile {
  onShowDeleteProfile: () => void;
  onSubmitDeleteProfile: () => void;
}

export enum FormInputNameFixClientData {
  name = 'name',
  email = 'email',
  phone = 'phone',
  birthDate = 'birthDate',
  motherName = 'motherName',
}

export enum FormInputNameFixAddress {
  id = 'id',
  zipCode = 'zipCode',
  state = 'state',
  city = 'city',
  district = 'district',
  street = 'street',
  number = 'number',
  complement = 'complement',
}
